import { Theme } from '@mui/material/styles';

// Scoped to boxes that hold a field label, so table edit cells and other
// inputs are left alone.
export const getProfileFieldsSx = (theme: Theme) => ({
  '& .MuiFormControlLabel-root': {
    background: 'transparent !important',
    height: 'auto !important',
    minHeight: 36,
    marginLeft: 0,
    gap: '12px',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      color: theme.custom?.brandNavy,
    },
  },
  // Profile forms use GridLegacy spacing={4|6}: keep a 32px column gap, drop
  // the row gap (each field has its own padding and line).
  '& .MuiGridLegacy-container[class*="MuiGridLegacy-spacing-xs-"]': {
    width: 'calc(100% + 32px)',
    marginTop: 0,
    marginLeft: '-32px',
    '& > .MuiGridLegacy-item': { paddingTop: 0, paddingLeft: '32px' },
  },
  '& .MuiBox-root:has(> label.MuiFormLabel-root)': {
    padding: '9px 0 8px',
    gap: '1px',
    rowGap: '1px',
    borderBottom: `1px solid ${theme.custom?.windowedHeaderLine}`,

    '& > label.MuiFormLabel-root, & > label.MuiFormLabel-root *': {
      height: 'auto',
      margin: 0,
      fontSize: '11px',
      lineHeight: 1.3,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: 'none',
      color: theme.custom?.tableHeaderText,
    },

    '& .MuiInputBase-root, & .MuiPickersInputBase-root': {
      width: 'calc(100% + 20px)',
      margin: '1px -10px 0',
      borderRadius: '8px',
      background: 'transparent',
      boxShadow: 'none',
      fontSize: '14.5px',
      fontWeight: 500,
      color: theme.custom?.brandNavy,
      transition: 'background-color 120ms, box-shadow 120ms',
      '&:not(.MuiInputBase-multiline)': { height: '24px' },
      '&:hover': { background: theme.custom?.fieldHoverBg },
      '&.Mui-focused': {
        background: theme.background.white,
        boxShadow: `0 0 0 3px ${theme.custom?.fieldFocusRing}`,
      },
      '&.Mui-disabled, &.Mui-readOnly': {
        '&:hover': { background: 'transparent' },
      },
    },
    '& .MuiOutlinedInput-notchedOutline, & .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: 'transparent !important',
      },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline, & .Mui-focused .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: `${theme.colors.primary.main} !important`,
        borderWidth: '1px',
      },
    '& .Mui-error .MuiOutlinedInput-notchedOutline, & .Mui-error .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: `${theme.palette.error.main} !important`,
      },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: '0 10px',
      lineHeight: '24px',
      '&::placeholder': {
        color: theme.custom?.fieldPlaceholder,
        opacity: 1,
        fontWeight: 400,
      },
    },
    '& .MuiInputBase-multiline .MuiInputBase-input': {
      padding: '4px 0',
      lineHeight: '20px',
    },
    '&& .MuiInputBase-root.Mui-disabled, && .MuiPickersInputBase-root.Mui-disabled':
      { background: 'transparent' },
    // Empty, unfocused date fields show "—" instead of MM/DD/YYYY.
    '& .MuiPickersInputBase-root:not(.Mui-focused):not(:has([role="spinbutton"]:not([aria-valuetext="Empty"]))) .MuiPickersSectionList-root':
      {
        '& .MuiPickersSectionList-section': { display: 'none' },
        '&::before': {
          content: '"—"',
          color: theme.custom?.fieldPlaceholder,
          fontWeight: 400,
        },
      },
    '&& .MuiPickersInputBase-root': { paddingLeft: 0 },
    '& .MuiPickersInputBase-sectionsContainer': {
      padding: '0 10px',
      lineHeight: '24px',
    },
    '& .MuiPickersInputBase-root:not(.Mui-focused) .MuiPickersSectionList-root[aria-valuetext=""], & .MuiPickersSectionList-sectionContent[aria-valuetext="Empty"]':
      { color: theme.custom?.fieldPlaceholder },
    '& .MuiPickersInputBase-root .MuiInputAdornment-root': {
      opacity: 0,
      transition: 'opacity 120ms',
      marginRight: '-4px',
    },
    '& .MuiPickersInputBase-root:hover .MuiInputAdornment-root, & .MuiPickersInputBase-root.Mui-focused .MuiInputAdornment-root':
      { opacity: 1 },
    '& .MuiSelect-select': {
      minHeight: 'auto !important',
      lineHeight: '24px',
      paddingRight: '28px !important',
    },
    '& .MuiSelect-icon': { opacity: 0, transition: 'opacity 120ms' },
    '& .MuiInputBase-root:hover .MuiSelect-icon, & .Mui-focused .MuiSelect-icon':
      { opacity: 1 },
  },
});
